import { gql } from '@apollo/client';

export const getTemplateQuestsQuery = gql`
    query GetTemplateQuests {
        quests(hasTemplateId: true) {
            id
            templateId
        }
    }
`;
